<template>
  <ui-dialog
    :isVisible="visible"
    :title="title"
    :isLoading="isLoading"
    ref="dialog"
    customClass="dialog-purchase-create-supplier"
    @close="handleClose"
  >
    <form-rfq-2-create
      ref="form"
      :model="formModel"
      :data="rfq2Data"
    />
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        isCancel
        isCreate
        @command="commandController"/>
    </template>
  </ui-dialog>
</template>

<script>
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { getDefaultRFQID } from '@/utils/shared'

export default {
  name: 'DialogCreateRFQ2',
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/Dialog'),
    'form-rfq-2-create': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQ2Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    rfqid: {
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      rfq2Data: {},
      visible: false
    }
  },
  computed: {
    title () {
      return this.rfq2Data.rfqid
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (isVisible) {
        this.visible = isVisible
        this.reset()
      }
    }
  },
  methods: {
    commandController (command) {
      if (command === 'cancel') {
        this.handleClose()
      } else if (command === 'save') {
        const form = this.$refs.form
        form.validate()
          .then(() => {
            const data = form.getData()
            this.createRFQ2s(data)
          })
      }
    },
    formModel () {
      let model = {
        ...ServiceRFQ2s.getModel(),
        rfqid: getDefaultRFQID(),
        employeeID: this.$store.getters.get('currentUser').employeeID
      }
      return model
    },
    reset () {
      this.rfq2Data = this.formModel()
    },
    createRFQ2s (data) {
      this.isLoading = true
      ServiceRFQ2s.post({ ...data, rfqid: this.rfqid })
        .then(_ => {
          this.handleClose()
          this.$emit('onCreated')
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleClose () {
      this.$emit('update:isVisible', false)
    }
  }
}
</script>
<style lang="stylus">
.dialog-purchase-create-supplier{
  width: 100%;
  max-width 100rem;
}
</style>
